import { FileType } from "@/types";

const isPdf = (input: FileType | string) => {
  if (typeof input == "object" && "ext" in input && input.ext === "pdf")
    return true;
  if (typeof input == "string" && getFileExtension(input) === "pdf")
    return true;
  return false;
};

const isImage = (fileType: FileType | string | undefined) => {
  if (
    typeof fileType == "object" &&
    "ext" in fileType &&
    (fileType.ext === "png" ||
      fileType.ext === "jpg" ||
      fileType.ext === "jpeg")
  )
    return true;
  if (
    typeof fileType == "string" &&
    ["png", "jpg", "jpeg"].includes(getFileExtension(fileType))
  )
    return true;
  return false;
};

const isCSV = (fileType: FileType | undefined) => {
  if (
    typeof fileType == "object" &&
    "ext" in fileType &&
    fileType.ext === "csv"
  )
    return true;
  if (typeof fileType == "string" && getFileExtension(fileType) === "csv")
    return true;
  return false;
};

function getFileExtension(fileName: string) {
  return fileName.substring(fileName.lastIndexOf(".") + 1);
}

export { isPdf, isImage, isCSV, getFileExtension };
